import React, { useEffect } from 'react';
import * as qs from 'qs';
import { FullScreenLoader } from '../../components';
import { encryptEmail, getMicrosoftAuthURL } from '../../utils/helpers';

const MicrosoftLoginScreen = () => {

    const host = qs.parse( window.location.search?.slice(1,) )?.host;

    useEffect(()=>{ 

        const microsoft_url = getMicrosoftAuthURL();
        const encryptedEmail = encryptEmail(host);

        localStorage.setItem('host', encryptedEmail);
        const anchor = document.createElement('a');
        anchor.href = microsoft_url;
        anchor.click();

    },[host]);
    return <FullScreenLoader />
}

export default MicrosoftLoginScreen;

// 